type Props = {
  label?: string;
  en: string;
  dark?: boolean;
  align?: "left" | "center";
  className?: string;
};

export default function SectionHeading({
  label,
  en,
  dark = false,
  align = "left",
  className = "",
}: Props) {
  return (
    <div
      className={`flex flex-col ${
        align === "center" ? "items-center text-center" : "items-start text-left"
      } ${className}`}
    >
      {label ? (
        <span
          className={`font-body text-xs tracking-[0.24em] md:tracking-[0.4em] uppercase ${
            dark ? "text-accent-300" : "text-secondary-500"
          }`}
        >
          {label}
        </span>
      ) : null}
      <h2
        className={`mt-3 font-display text-4xl md:text-5xl lg:text-6xl font-light tracking-[0.06em] ${
          dark ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {en}
      </h2>
    </div>
  );
}